import { Machine } from "../types";

function normalizedMachineNameSort(machines: Machine[]) {
  return machines.sort((a, b) => {
    const normalize = (name: string) => name.replace(/^\s*the\s+/i, "").trim();
    return normalize(a.machineGroupName).localeCompare(
      normalize(b.machineGroupName)
    );
  });
}

export default normalizedMachineNameSort;
